import { INPUT_TYPE } from "./constants";

function requiredCheck(field) {
	return function (val) {
		if (val !== undefined && val !== null && val !== "") return true;
		throw new Error(`${field.label || field.name} is required`);
	};
}

function optionsCheck(field) {
	return function (val) {
		for (const option in field?.options) {
			if (val === field.options[option]?.value) return true;
		}
		throw new Error(`Invalid Option Selected for ${field.label || field.name}`);
	};
}

function listCheck(field) {
	return function (val) {
		if (val?.length) return true;
		throw new Error(`${field.label || field.name} can't be empty`);
	};
}

function numberCheck(field) {
	return function (val) {
		if (isNaN(val)) {
			throw new Error(`${field.label || field.name} is not a valid number`);
		} else {
			return true;
		}
	};
}

function dateCheck(field) {
	return function(val) {
		if(val?.length) {
			for(const date of val) {
				const parsedDate = new Date(date).getTime();
				if(isNaN(parsedDate)) throw new Error(`Invalid Date ${date} found in the list`);
			}
			return true;
		}
		throw new Error(`${field.label || field.name} can't be empty`)
	}
}

export function createValidationSchema(config) {
	let mappedValidators = {};

	for (const section in config) {
		const fields = config[section].fields;
		for (const field of fields) {
			const { required, type, name, customValidator } = field;

			mappedValidators[name] = {
				validators: [],
				required,
			};

			if (required) {
				mappedValidators[name].validators.push(requiredCheck(field));
			}

			switch (type) {
				case INPUT_TYPE.LIST:
					if (required) {
						mappedValidators[name].validators.push(listCheck(field));
					}
					break;

				case INPUT_TYPE.NUMBER:
					mappedValidators[name].validators.push(numberCheck(field));
					break;

				case INPUT_TYPE.SELECT:
					mappedValidators[name].validators.push(optionsCheck(field));
					break;

				case INPUT_TYPE.DATES:
					mappedValidators[name].validators.push(dateCheck(field));
					break;

				default:
					break;
			}

			if (customValidator) {
				mappedValidators[name].validators.push(customValidator);
			}
		}
	}

	return mappedValidators;
}

export function validateForm(mappedValidators, formData) {
	let mappedErrors = {},
		ok = true;

	for (const field in mappedValidators) {
		const { validators, required } = mappedValidators[field];

		if (!formData[field] && !required) continue;

		for (const validator of validators) {
			try {
				validator(formData[field]);
			} catch (error) {
				ok = false;
				mappedErrors[field] = error.message;
				break;
			}
		}
	}

	return { mappedErrors, ok };
}
